import {WicketUserDataDictionaryField} from '../wicket-user-data-dictionary-field';

export type WicketLocaleOverride<PropertyName extends string, PropertyType> = {
  language_code: string;
} & {[P in PropertyName]: PropertyType};
